// extracted by mini-css-extract-plugin
export default {"home":"Home_home__qwgF-","content":"Home_content__nQy7v"};